import React from 'react'
import tw, { styled } from 'twin.macro'
import { Link, useStaticQuery, graphql } from 'gatsby'

const Section = styled.section`
	${tw`flex items-center justify-center px-4 py-3 md:py-10`}
`

const RoundedContainer = styled.div`
	border-radius: clamp(16px, 4vw, 40px);
	overflow: hidden;
	max-width: 1100px;
	width: 100%;
`

const Banner = styled.div`
	${tw`relative w-full`}
`

const BannerImage = styled.img`
	${tw`w-full block`}
`

const ButtonWrapper = styled.div`
	${tw`hidden sm:flex absolute inset-x-0 justify-center`}
	bottom: 22%;
`

const Button = styled(Link)`
	${tw`inline-flex items-center justify-center bg-white text-black font-black py-4 px-14 rounded-full text-xl hover:bg-gray-200 transition duration-300 shadow-lg`}
	text-decoration: none;
`

const MobileButton = styled(Link)`
	${tw`sm:hidden font-semibold cursor-pointer inline-flex items-center justify-center mt-4`}
	background: transparent;
	color: black;
	border: 2px solid black;
	border-radius: 9999px;
	font-size: 0.9rem;
	text-decoration: none;
	padding: 0.65rem 2.5rem;
	min-height: 44px;
	margin-left: auto;
	margin-right: auto;
`

const BannerButton = () => {
	const { banner } = useStaticQuery(bannerButtonQuery)
	const data = banner?.nodes?.[0]

	if (!data) return null

	return (
		<Section>
			<div css={[tw`flex flex-col items-center w-full`]} style={{ maxWidth: '1100px' }}>
				<RoundedContainer>
					<Banner>
						<BannerImage src={data.backgroundImage?.file?.url} alt="" />
						<ButtonWrapper>
							<Button to={'/' + data.mainActionUrl}>{data.mainActionText}</Button>
						</ButtonWrapper>
					</Banner>
				</RoundedContainer>
				<MobileButton to={'/' + data.mainActionUrl}>{data.mainActionText}</MobileButton>
			</div>
		</Section>
	)
}

export const bannerButtonQuery = graphql`
	query bannerButtonQuery {
		banner: allContentfulBanner(
			filter: { contentful_id: { eq: "2WpqfDy2YNk10fNXbzrZ2N" }, node_locale: { eq: "en-AU" } }
		) {
			nodes {
				backgroundImage {
					file {
						url
					}
				}
				mainActionText
				mainActionUrl
			}
		}
	}
`

export default BannerButton
